import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Container, Row, Col } from 'reactstrap';
import { TextHeader } from '../../../Controls/Digital/TextHeaders';
import { YoutubeEmbed } from '../../../Controls/Digital/YouTubeEmbed'
import imgBoundaySouth from '../Resources/Images/Boundary_South.jpg';
import imgBoundayNorth from '../Resources/Images/Boundary_North.jpg';

const About = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="about" isAlt={false}>

            <TextHeader text={
                <Fragment>
                    Register Now!!!
                </Fragment>
            } />
            <YoutubeEmbed embedId="QWkobNTcYfE" />

            <TextHeader text={
                <Fragment>
                    Some story about the cup...
                </Fragment>
            } />
            <YoutubeEmbed embedId="kArJPmX7si4" />

            <TextHeader text={
                <Fragment>
                    about
                </Fragment>
            } />

            <ContentAboutWrapper
                header="What is the Kingfish cup?"
                content={
                    <Fragment>
                        The  Kingfish Cup is about bringing the Spearo tribe together and of course spearing a kingfish over one weekend in Sydney’s prime Yellowtail Kingfish season, traditionally this is late October through November.
                    </Fragment>
                } />


            <ContentAboutWrapper
                header="Where is it held?"
                content={
                    <Fragment>
                        “Greater Sydney” is the area entrants may enter. It stretches from BlacksSmith's North Rock wall in the Central Coast to Bass Point in the South covering just over 275 kilometres of coastline.
                        Weigh in stations are at Adreno Sydney itself, Little Manly in Sydney Harbour, both Terrigal and Norah Head on the Central Coast, and of course Wollongong too.
                    </Fragment>
                } />


            <ContentAboutWrapper
                header="Boundaries Map"
                content={
                    <Fragment>
                        <Row>
                            <Col lg={{ size: 11, offset: 1 }} xs={{ size: 12 }}>
                                <Container>
                                    <Row>
                                        <Col lg="6" className="text-center">
                                            <Container>
                                                <Row>
                                                    <Col>
                                                        North Boundary - <b>BlacksSmith's North Rock wall</b>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <img src={imgBoundayNorth} className="img-fluid" />
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Col>
                                        <Col lg="6" className="text-center">
                                            <Container>
                                                <Row>
                                                    <Col>
                                                        South Boundary - <b>Bass Pont</b>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <img src={imgBoundaySouth} className="img-fluid" />
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        </Row>
                    </Fragment>
                } />


            <ContentAboutWrapper
                header="Who enters the KFC?"
                content={
                    <Fragment>
                        The Kingfish Cup attracts a broad mix of entrants across age groups, genders and locations. Based on recent years, we expect more than 250 spearfishers to enter, ranging from sub-juniors aged 14 to Grand Masters aged over 65. Women’s participation has also been strong, with 19 women competing last year. Divers travel from as far as Queensland to take part. The event appeals not only to experienced competitors, but also to recreational spearfishers and relative newcomers—some of whom spear their first kingfish during the Kingfish Cup.
                    </Fragment>
                } />

            <ContentAboutWrapper
                header="How does it work?"
                content={
                    <Fragment>
                        The USFA runs the event, we work with the Adreno Sydney team, and it has been a successful partnership.  Prior to the event, some 8 days before, we host the Information Night a social “get together” (200 attendees last year) at Adreno – we put on some great food – one of our members “the Paella King” creates amazing paella; we explain the simple rules and discuss the ethics and integrity required for everyone to enjoy the event; we have guest speakers (spearfishing gurus) that discuss kingfish habits and hunting tips, the USFA supports real, unbiased science and this year our Fisheries biologists will divulge their latest Kingfish findings.  The Information night is the spearos social night of the year.

                        Since the running of the inaugural event in 2019 we have seen healthy registration numbers, now numbering over 250 entrants, thus it requires a lot of organising from an efficient team.  Entrants register online, here they are given details of the event and how to “sign on” and “sign off” (any times between 0800 and 1600 you may fish multiple times on a day) on each day – (some entrants fish only one day) this lets organisers know who is in the water and importantly when they are back out – safety is paramount.  On safety, the organisers also make the decision on postponing the days fishing if the weather is decided to be inclement.

                        The fish are weighed in at the weigh stations, we try to keep the weights discreet to build some atmosphere for the presentation night the Thursday following the event.
                    </Fragment>
                } />

            <ContentAboutWrapper
                header="The event is ethical! Sustainable too! "
                content={
                    <Fragment>
                        Kingfish are in healthy numbers along Australia’s east coast. Last year (’25) when we held the Cup over two days, we had 261 divers enter in the water for approximately 1219 hours of the 22 Kingfish that were caught it worked out to over 55 hours of effort per fish, with a mean weight average of 9.79 kilograms per fish.  Spearfishing is amazing.
                    </Fragment>
                } />
        </Block>
    );
}
export default About;

const ContentAboutWrapper = (props) => {
    return (
        <Row>
            <Col lg={{ site: 10, offset: 1 }} className="definition">
                <p>
                    <b>{props.header}</b>
                </p>
                <p>
                    {props.content}
                </p>
            </Col>
        </Row>
    );
}